import RegistrarCard from './RegistrarCard';
export default RegistrarCard;
